<div class="d-block px-1">
    <div class="d-flex text-start text-gray-color f-14 font-semibold mb-1">{{ params.headerNameTop }}</div>
    <div class="d-flex text-start text-gray-color f-14 font-semibold mb-1">{{ params.headerNameBottom }}</div>
</div>
